import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const GoBackButton = ({ label = "Go Back" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
  const role = auth.role;

  // Determine user's dashboard
  const getDashboardPath = () => {
    if (role === "Admin") return "/pos/orders";
    return "/pos/sell"; // Salesperson
  };

  const handleGoBack = () => {
    // Special case for payment slip
    if (location.pathname === "/pos/payment-slip") {
      navigate("/pos/sell", { replace: true });
      return;
    }

    // Normal back behavior
    if (window.history.state && window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(getDashboardPath(), { replace: true });
    }
  };

  // Hide on dashboard pages
  const dashboardPath = getDashboardPath();
  if (location.pathname === dashboardPath) return null;

  return (
    <div className="w-full flex items-center mb-3">
      <button
        onClick={handleGoBack}
        className="flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-800 active:scale-95"
      >
        ← {label}
      </button>
    </div>
  );
};

export default GoBackButton;
